import React, { useState, useEffect } from "react";
import Grid from "@mui/material/Grid";
import DataTable from "../../components/DataTable/index";
import { makeStyles } from "@mui/styles";
import {
  Button,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Paper,
  TextField,
  Alert,
  Chip,
  Box,
  CircularProgress,
} from "@mui/material";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";

import { useParams } from "react-router-dom";

import { styled } from "@mui/material/styles";

// import data from "./data";

import {
  addAdminAddPlayerScores,
  clearLeaderboardProjectedScore,
  getLeaderboardProjectedScore,
} from "../../redux/actions/leaderboard-actions";
import Checks from "../../components/checks";
import imgMedal1 from "../../assets/images/madel-1.png";
import imgMedal2 from "../../assets/images/madel-2.png";
import imgMedal3 from "../../assets/images/madel-3.png";
import imgMedal4 from "../../assets/images/madel-star.png";

const useStyles = makeStyles((theme) => ({
  outlineInputBorder: {
    "& * > fieldset > legend": {
      display: "none",
    },
  },
  stack1: {
    backgroundColor: "#C4C4C4",
    borderRadius: "5px",
  },
  stack2: {
    backgroundColor: "#2C633C",
    borderRadius: "5px",
  },
  tournamnetBox: {
    // padding:""
    // width: "138px",
    // textAlign: "center",
  },
  divider: {
    border: "1px solid black !important",
    height: "5px !important",
  },
  dividerBox: {
    backgroundColor: "black !important",
  },
  groupingBox: {
    backgroundColor: "#06623B",
  },
  createDrawsBtnContainer: {
    display: "flex",
  },

  createDrawsText: {
    fontWeight: "bolder  !important",
    marginLeft: "5px  !important",
  },
  addGroupCard: {
    border: "2px dashed grey",
    display: "flex",
  },
  mainTextfield: {
    "& *": {
      borderRadius: "0px !imptant",
      textAlign: "center !important",
      width: "30px",
      height: "30px",
      fontSize: "12px !important",
      marginTop: "10px",
    },
    "& > div > input": {
      marginTop: "-10px",
    },
    alignItems: "center",
  },
  scrollBarStyle: {
    // Width
    "&::-webkit-scrollbar": {
      width: "5px !important",
    },
    // Track
    "&::-webkit-scrollbar-track": {
      background: "#C4C4C4 !important",
      marginTop: "25px !important",
    },
    // Handle
    "&::-webkit-scrollbar-thumb": {
      background: "#06623B !important",
      borderTop: "50px solid #C4C4C4 !important",
    },
    // Handle on Hover
    "&::-webkit-scrollbar-thumb:hover": {
      background: "#06623B !important",
    },
  },
}));

const ExpandedComponent = (row) => {
  const { data, someTitleProp } = row;

  const id = useParams();
  const dispatch = useDispatch();
  const classes = useStyles();
  const getProjectedScores = useSelector(
    (state) => state?.getProjectedScoresByID?.data?.data
  );

  const [tableRows, setTableRows] = useState({
    putts: [],
    score: [],
    indexes: [],
    gir: [],
    fir: [],
    par: [],
  });

  const [totalGirSum, setTotalGirSum] = useState({
    girSum: "",
    firSum: "",
  });
  const [filteredScore, setFilteredScore] = useState([]);
  const [filteredPutts, setFilteredPutts] = useState(Array(18).fill(0));
  const [success, setSuccess] = useState(false);
  const [expandSuccess, setExpandSuccess] = useState(true);

  const _handleChangeScoreValue = (e, index) => {
    const { value } = e.target;

    if (value.length <= 2) {
      if (!isNaN(value)) {
        var score = tableRows?.score;
        score[index] = parseInt(value);

        score = tableRows.score.filter((e) => e !== undefined);

        // Sum work
        var s_outSum = 0;
        var s_inSum = 0;
        var total = 0;
        score?.forEach((v, i) => {
          if (i < 9) {
            s_outSum += parseInt(v);
          }
          if (i > 9 && i <= 18) {
            s_inSum += parseInt(v);
          }
          total = s_outSum + s_inSum;
        });

        score[9] = s_outSum;
        score[19] = s_inSum;
        score[20] = total;

        setTableRows({ ...tableRows, score });

        setTableRows({ ...tableRows, score });

        var scoreVals = tableRows.score.map((item, i) => {
          return {
            score: item,
            hole: i + 1,
          };
        });

        setFilteredScore(scoreVals);
      }
    }
  };

  const _handleChangePuttValue = (e, index) => {
    const { value } = e.target;

    if (value.length <= 2) {
      if (!isNaN(value)) {
        var putts = tableRows?.putts;
        putts[index] = parseInt(value);

        putts = tableRows.putts.filter((e) => e !== undefined);

        // Sum work
        var p_outSum = 0;
        var p_inSum = 0;
        var p_total = 0;
        putts?.forEach((v, i) => {
          if (i < 9) {
            p_outSum += parseInt(v);
          }
          if (i > 9 && i <= 18) {
            p_inSum += parseInt(v);
          }
          p_total = p_outSum + p_inSum;
        });
        putts[9] = p_outSum;
        putts[19] = p_inSum;
        putts[20] = p_total;

        setTableRows({ ...tableRows, putts });

        var puttsVals = tableRows.putts.map((item, i) => {
          return {
            putts: item,
          };
        });

        setFilteredPutts(puttsVals);
      }
    }
  };

  const _handleClickGirNo = (e, index) => {
    let gir = tableRows.gir;
    gir[index] = 0;

    let gir_outSum = 0;
    let gir_outPerc = 0;
    let gir_inSum = 0;
    let gir_inPerc = 0;
    let total = 0;

    let sub_gir = 0;
    gir.forEach((v, i) => {
      if (i < 9 && v == 1) {
        gir_outSum += parseInt(v);
        gir_outPerc = (gir_outSum / 18) * 100;
      }
      if (i > 9 && i <= 18 && v == 1) {
        gir_inSum += parseInt(v);
        gir_inPerc = (gir_inSum / 18) * 100;
      }
    });

    total = gir_outPerc + gir_inPerc;
    gir[9] = gir_outPerc.toFixed(3);
    gir[19] = gir_inPerc.toFixed(3);
    gir[20] = total.toFixed(3);
    setTableRows({ ...tableRows, gir });
  };

  const _handleClickGirYes = (e, index) => {
    let gir = tableRows.gir;
    gir[index] = 1;

    let gir_outSum = 0;
    let gir_outPerc = 0;
    let gir_inSum = 0;
    let gir_inPerc = 0;
    let total = 0;
    gir.forEach((v, i) => {
      if (i < 9 && v == 1) {
        gir_outSum += parseInt(v);
        gir_outPerc = (gir_outSum / 18) * 100;
      }
      if (i > 9 && i <= 18 && v == 1) {
        gir_inSum += parseInt(v);
        gir_inPerc = (gir_inSum / 18) * 100;
      }
    });

    total = gir_outPerc + gir_inPerc;

    gir[9] = gir_outPerc.toFixed(3);
    gir[19] = gir_inPerc.toFixed(3);
    gir[20] = total.toFixed(3);

    setTableRows({ ...tableRows, gir });
  };

  const _handleClickFirNo = (e, index) => {
    let fir = tableRows.fir;
    fir[index] = 0;
    let fir_outSum = 0;
    let fir_outPerc = 0;
    let fir_inSum = 0;
    let fir_inPerc = 0;
    let total = 0;
    fir.forEach((v, i) => {
      if (i < 9 && v == 1) {
        fir_outSum += parseInt(v);
        fir_outPerc = (fir_outSum / 18) * 100;
      }
      if (i > 9 && i <= 18 && v == 1) {
        fir_inSum += parseInt(v);
        fir_inPerc = (fir_inSum / 18) * 100;
      }
    });

    total = fir_outPerc + fir_inPerc;
    fir[9] = fir_outPerc.toFixed(3);
    fir[19] = fir_inPerc.toFixed(3);
    fir[20] = total.toFixed(3);
    setTableRows({ ...tableRows, fir });
  };

  const _handleClickFirYes = (e, index) => {
    let fir = tableRows.fir;
    fir[index] = 1;

    let fir_outSum = 0;
    let fir_outPerc = 0;
    let fir_inSum = 0;
    let fir_inPerc = 0;
    let total = 0;
    fir.forEach((v, i) => {
      if (i < 9 && v == 1) {
        fir_outSum += parseInt(v);
        fir_outPerc = (fir_outSum / 18) * 100;
      }
      if (i > 9 && i <= 18 && v == 1) {
        fir_inSum += parseInt(v);
        fir_inPerc = (fir_inSum / 18) * 100;
      }
    });

    total = fir_outPerc + fir_inPerc;

    fir[9] = fir_outPerc.toFixed(3);
    fir[19] = fir_inPerc.toFixed(3);
    fir[20] = total.toFixed(3);
    setTableRows({ ...tableRows, fir });
  };

  const onSubmitAddScoreCard = () => {
    let l_gir = tableRows.gir;
    l_gir.splice(9, 1);

    l_gir.splice(18, 1);
    let girTotal = l_gir.splice(18, 1);
    l_gir.splice(18, 2);

    let l_score = tableRows.score;
    l_score.splice(9, 1);
    l_score.splice(18, 5);

    let l_putts = tableRows.putts;
    l_putts.splice(9, 1);
    l_putts.splice(18, 4);

    let l_fir = tableRows.fir;
    l_fir.splice(9, 1);
    l_fir.splice(18, 1);
    let firTotal = l_fir.splice(18, 1);
    l_fir.splice(18, 2);

    const dataObj = l_score.map((item, i) => {
      return {
        hole: i + 1,
        score: item,
        putts: l_putts[i],
        fir: l_fir[i],
        gir: l_gir[i],
      };
    });

    let adjScore = 0,
      grossScore = 0;
    const filteredParList = tableRows.par.filter((par) => par != null);
    for (let i = 0; i < 18; i++) {
      const targetPar = +filteredParList[i] + 3;
      const sc = l_score[i];
      if (sc >= targetPar) adjScore += filteredParList[i] + 2;
      else adjScore += sc;

      grossScore += l_score[i];
    }

    const dataObj2 = {
      gross_score: grossScore,
      adjusted_score: adjScore,
      user_id: data.user_id,
      user_tee: data.user_tee,
      playing_handicap: data.playing_handicap,
      fir: firTotal[0],
      gir: girTotal[0],
      user_scores: dataObj,
    };

    dispatch(addAdminAddPlayerScores(dataObj2, id.id));
    // dispatch(getLeaderboardProjectedScore(id.id));
    // dispatch(getLeaderboardProjectedScore(id.id));
    // dispatch(getLeaderboardProjectedScore(id.id));
    someTitleProp(false);
    setSuccess(true);
    setInterval(() => {
      setSuccess(false);
    }, 3000);
  };

  useEffect(() => {
    var p_values = [];
    var s_values = [];
    var l_index = [];
    var gir = [];
    var fir = [];
    var par = [];

    if (data?.score_card.length > 0) {
      data?.score_card?.map((item, i) => {
        return par.push(item.par);
      });
    }

    if (data?.score_card.length > 0) {
      for (var i = 0; i <= 20; i++) {
        l_index.push(data?.score_card[i]?.index);
      }
    }
    l_index.splice(9, 0, 0);

    if (data?.score_card.length > 0) {
      for (var i = 0; i <= 19; i++) {
        gir.push(data?.score_card[i]?.gir);
      }
    }
    gir.splice(9, 0, 0);
    gir.splice(19, 0, 0);
    gir.splice(20, 0, 0);

    if (data?.score_card.length > 0) {
      for (var i = 0; i <= 19; i++) {
        if (par[i] == 4 || par[i] == 5) {
          if (data?.score_card[i]?.fir == 0) {
            fir.splice(i, 0, 0);
          } else if (data?.score_card[i]?.fir == 1) {
            fir.splice(i, 0, 1);
          } else {
            fir.splice(i, 0, 4);
          }
        } else if (par[i] !== 4 || par[i] !== 5) {
          fir.splice(i, 0, 3);
        }
      }

      var fir_outSum = 0;
      var fir_inSum = 0;
      var fir_inPerc = 0;
      var fir_outPerc = 0;
      var total = 0;
      fir.forEach((v, i) => {
        if (i < 9 && v == 4) {
          fir_outSum += parseInt(v);
          fir_outPerc = (fir_outSum / 18) * 100;
        }
        if (i > 9 && i <= 18 && v == 4) {
          let val = 1;
          fir_inSum += parseInt(val);
          fir_inPerc = (fir_inSum / 18) * 100;
        }
      });
      total = fir_outPerc + fir_inPerc;
    }
    fir.splice(9, 0, NaN);
    fir.splice(19, 0, NaN);
    fir.splice(20, 0, NaN);

    if (data?.score_card.length > 0) {
      for (var i = 0; i <= 20; i++) {
        p_values.push(data?.score_card[i]?.putts || 0);
      }

      for (var i = 0; i <= 20; i++) {
        s_values.push(data?.score_card[i]?.score || 0);
      }

      s_values.filter((e) => e !== undefined);

      let p_outSum = 0;
      let p_inSum = 0;
      let p_total = 0;

      p_values?.forEach((v, i) => {
        if (i < 9) {
          p_outSum += parseInt(v);
        }
        if (i > 9 && i < 18) {
          p_inSum += parseInt(v);
        }
        p_total = p_outSum + p_inSum;
      });

      p_values.splice(9, 0, p_outSum);
      p_values[19] = p_inSum;
      p_values[20] = p_total;

      let s_outSum = 0;
      let s_inSum = 0;
      let s_total = 0;
      s_values?.forEach((v, i) => {
        if (i < 9) {
          s_outSum += parseInt(v);
        } else if (i >= 9 && i <= 18) {
          s_inSum += parseInt(v);
        }
        s_total = s_outSum + s_inSum;
      });
      s_values.splice(9, 0, s_outSum);
      s_values[19] = s_inSum;
      s_values[20] = s_total;

      setTableRows({
        ...tableRows,
        putts: p_values,
        score: s_values,
        indexes: l_index,
        gir: gir,
        fir: fir,
        par: par,
      });
    }
  }, []);

  return (
    <>
      {success && (
        <Alert severity="success">Score card added successfully</Alert>
      )}
      <TableContainer component={Paper}>
        <Table aria-label="simple table">
          <TableBody
            sx={{
              "& > tr:nth-child(even)": {
                backgroundColor: "#F2F2F2",
              },
              "& > tr > td:nth-child(1)": {
                textAlign: "center",
                fontSize: "13px",
              },
              "& > tr > td:not(:first-child)": {
                padding: 0,
                textAlign: "center",
                fontSize: "12px",
              },
            }}
          >
            <TableRow>
              <TableCell>Holes</TableCell>
              {data?.score_card?.map((x, i) => {
                if (i < 9) {
                  return <TableCell>{x.hole}</TableCell>;
                } else if (i === 9) {
                  return (
                    <>
                      <TableCell>{x.hole2}</TableCell>
                      <TableCell>{x.hole}</TableCell>
                    </>
                  );
                } else if (i >= 10 && i < 18) {
                  return <TableCell>{x.hole}</TableCell>;
                } else if (i >= 18) {
                  return <TableCell>{x.hole2}</TableCell>;
                }
              })}
            </TableRow>
            <TableRow>
              <TableCell>Index</TableCell>
              {tableRows.score &&
                tableRows?.indexes?.map((x, i) => {
                  if (i < 9) {
                    return <TableCell>{x}</TableCell>;
                  } else if (i === 9) {
                    return (
                      <>
                        <TableCell></TableCell>
                      </>
                    );
                  } else if (i >= 10 && i <= 18) {
                    return <TableCell>{x}</TableCell>;
                  } else if (i > 18) {
                    return <TableCell>{/* {x.hole2} */}</TableCell>;
                  }
                })}
            </TableRow>
            <TableRow style={{ borderBottom: "3px solid #06623B" }}>
              <TableCell>Par</TableCell>
              {data?.score_card?.map((x, i) => {
                if (i < 9) {
                  return <TableCell>{x.par}</TableCell>;
                } else if (i === 9) {
                  return (
                    <>
                      <TableCell>{x.parTO}</TableCell>
                      <TableCell>{x.par}</TableCell>
                    </>
                  );
                } else if (i >= 10 && i < 18) {
                  return <TableCell>{x.par}</TableCell>;
                } else if (i >= 18) {
                  return <TableCell>{x.parT}</TableCell>;
                }
              })}
            </TableRow>
            <TableRow>
              <TableCell>Strokes</TableCell>
              {tableRows.score &&
                tableRows.score?.map((x, i) => {
                  if (i < 9) {
                    return (
                      <TableCell>
                        <TextField
                          sx={{ textAlign: "center" }}
                          onChange={(e) => _handleChangeScoreValue(e, i)}
                          className={`${classes.outlineInputBorder} ${classes.mainTextfield}`}
                          value={x}
                          type="number"
                        />
                      </TableCell>
                    );
                  } else if (i === 9) {
                    return (
                      <>
                        <TableCell>{x}</TableCell>
                      </>
                    );
                  } else if (i >= 10 && i <= 18) {
                    return (
                      <TableCell>
                        <TextField
                          onChange={(e) => _handleChangeScoreValue(e, i)}
                          className={`${classes.outlineInputBorder} ${classes.mainTextfield}`}
                          value={x}
                          type="number"
                        />
                      </TableCell>
                    );
                  } else if (i >= 17 && i <= 20) {
                    return <TableCell>{x}</TableCell>;
                  }
                })}
            </TableRow>
            <TableRow style={{ borderBottom: "3px solid #06623B" }}>
              <TableCell>Net Score</TableCell>
              {data?.score_card.map((x, i) => {
                if (i < 9) {
                  return <TableCell>{x.net}</TableCell>;
                } else if (i === 9) {
                  return (
                    <>
                      <TableCell>{x.net}</TableCell>
                    </>
                  );
                } else if (i >= 10 && i < 18) {
                  return <TableCell>{x.net}</TableCell>;
                } else if (i >= 17) {
                  return <TableCell>{x.net}</TableCell>;
                }
              })}
            </TableRow>
            <TableRow>
              <TableCell>Putts</TableCell>
              {tableRows.putts &&
                tableRows?.putts?.map((x, i) => {
                  if (i < 9) {
                    return (
                      <TableCell>
                        <TextField
                          onChange={(e) => _handleChangePuttValue(e, i)}
                          className={`${classes.outlineInputBorder} ${classes.mainTextfield}`}
                          value={x}
                          type="number"
                        />
                      </TableCell>
                    );
                  } else if (i === 9) {
                    return (
                      <>
                        <TableCell>{x}</TableCell>
                      </>
                    );
                  } else if (i >= 10 && i <= 18) {
                    return (
                      <TableCell>
                        <TextField
                          onChange={(e) => _handleChangePuttValue(e, i)}
                          className={`${classes.outlineInputBorder} ${classes.mainTextfield}`}
                          value={x}
                          type="number"
                        />
                      </TableCell>
                    );
                  } else if (i >= 17 && i <= 20) {
                    return <TableCell>{x}</TableCell>;
                  }
                })}
            </TableRow>
            <TableRow>
              <TableCell>FIR</TableCell>
              {tableRows.fir.map((x, i) => {
                if ((i < 9 && x == 4) || x == 1 || x === 0) {
                  return (
                    <TableCell>
                      <Checks
                        _handleClickNo={(e) => _handleClickFirNo(e, i)}
                        _handleClickYes={(e) => _handleClickFirYes(e, i)}
                        value={x}
                      />
                    </TableCell>
                  );
                } else if (i < 9 && x == 3) {
                  return <TableCell></TableCell>;
                } else if (i === 9 || x === "0.000") {
                  // return <TableCell>{x === NaN ? 0 : x}%</TableCell>;
                  return <TableCell>{isNaN(x) ? " " : x + "%"}</TableCell>;
                } else if (
                  (i >= 10 && i <= 18 && x == 4) ||
                  x == 1 ||
                  x === 0
                ) {
                  return (
                    <TableCell>
                      <Checks
                        _handleClickNo={(e) => _handleClickFirNo(e, i)}
                        _handleClickYes={(e) => _handleClickFirYes(e, i)}
                        value={x}
                      />
                    </TableCell>
                  );
                } else if (i >= 10 && i <= 18 && x == 3) {
                  return <TableCell></TableCell>;
                } else if (i > 18 && i <= 20) {
                  // setTotalGirSum({...totalGirSum, girSum: x})
                  return <TableCell>{isNaN(x) ? " " : x + "%"}</TableCell>;
                }
              })}
            </TableRow>
            <TableRow
              style={{
                borderBottom: "3px solid #06623B",
              }}
            >
              <TableCell>GIR</TableCell>
              {tableRows.gir.map((x, i) => {
                if (i < 9) {
                  return (
                    <TableCell>
                      <Checks
                        _handleClickNo={(e) => _handleClickGirNo(e, i)}
                        _handleClickYes={(e) => _handleClickGirYes(e, i)}
                        value={x}
                        // defaultChecked={x == 0 ? true : false }
                      />
                    </TableCell>
                  );
                } else if (i === 9) {
                  return <TableCell>{x}%</TableCell>;
                } else if (i >= 10 && i <= 18) {
                  return (
                    <TableCell>
                      <Checks
                        _handleClickNo={(e) => _handleClickGirNo(e, i)}
                        _handleClickYes={(e) => _handleClickGirYes(e, i)}
                        value={x}
                      />
                    </TableCell>
                  );
                } else if (i > 18 && i <= 20) {
                  return <TableCell>{x}%</TableCell>;
                }
              })}
            </TableRow>
            <TableRow>
              <TableCell colSpan={22} sx={{ textAlign: "end !important" }}>
                <Button variant="contained" onClick={onSubmitAddScoreCard}>
                  Save
                </Button>
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

function POTYTournamentDetails(props) {
  const { leaderboardScoreVal, someTitleProp } = props;
  const classes = useStyles();
  const { id } = useParams();
  const dispatch = useDispatch();
  const [rowExpanded, setRowExpanded] = useState();
  const [dataProgressPending, setDataProgressPending] = useState(false);
  const [leaderboardProjectedScoreData, setLeaderboardProjectedScoreData] =
    useState([]);
  const [pointsystem, setPointsystem] = useState([]);
  const [scoreMultiplyer, setScoreMultiplyer] = useState("");
  const [ranking, setRanking] = useState([]);
  const [points, setPoints] = useState([]);

  const setExpandedRow = (row) => {
    // setexpandableRowExpanded(row)
  };
  //#region redux selector
  const tournamentName = useSelector(
    (state) => state?.getOneTournamentReducer?.data?.tournament_name
  );
  const courseName = useSelector(
    (state) => state?.getOneTournamentReducer?.data?.course_name
  );
  const sponsorName = useSelector(
    (state) => state?.getOneTournamentReducer?.data?.sponsor_name
  );

  const teeOff_time = useSelector(
    (state) => state?.getOneTournamentReducer?.data?.tee_off
  );

  const tournamentLeaderboardData = useSelector(
    (state) => state?.getOneTournamentReducer?.data
  );

  const tournamentLeaderboardProjectedScore = useSelector(
    (state) => state?.getProjectedScoresByID?.data
  );

  const detailAdminsAddPlayerScore = useSelector(
    (state) => state?.createAdminsAddPlayerScore?.data
  );

  const tournamentLeaderboardProjectedScoreLoading = useSelector(
    (state) => state?.getProjectedScoresByID?.loading
  );

  const [successExpand, setSuccessExpand] = useState(false);

  //#endRegion
  useEffect(() => {
    if (detailAdminsAddPlayerScore?.error === false) {
      setSuccessExpand(!successExpand);
    }
  }, [detailAdminsAddPlayerScore]);

  const filterRank = (id) => {
    if (ranking[id] === undefined) {
      return id + 1;
    } else {
      return ranking[id];
    }
  };

  const getPoints = (data, id) => {
    if (data.projected) {
      return parseFloat(points[id]).toFixed(2);
    } else {
      return "-";
    }
  };

  useEffect(() => {
    setDataProgressPending(props.dataProgressPending);
  }, [props.dataProgressPending]);

  useEffect(() => {
    dispatch(getLeaderboardProjectedScore(id));
    return () => {
      dispatch(clearLeaderboardProjectedScore());
    };
  }, []);

  // Ranking
  const rankingCal = (arr) => {
    let tempArr = [];

    // Remove Empty Score Players
    for (let a = 0; a < arr.length; a++) {
      if (arr[a].projected) {
        tempArr.push(arr[a]);
      }
    }

    // Sort Position
    let rank = tempArr.map(
      (x, y, z) => z.filter((w) => w.projected.net < x.projected.net).length + 1
    );

    // Rank Calculation
    let rankingT = [...rank];
    for (let a = 0; a < tempArr.length; a++) {
      if (a === 0) {
        if (rank[a] === rank[a + 1]) {
          rankingT[a] = `T${rank[a]}`;
        }
      }
      if (a > 0 && a < rank.length) {
        if (rank[a] === rank[a - 1] || rank[a] === rank[a + 1]) {
          rankingT[a] = `T${rank[a]}`;
        }
      }
      if (a === tempArr.length - 1) {
        if (rank[a] === rank[a - 1]) {
          rankingT[a] = `T${rank[a]}`;
        }
      }
    }

    // Points Calculation
    let points = [];
    for (let a = 0; a < tempArr.length; a++) {
      let counter = 0;
      let total = 0;
      let avg = 0;

      for (let b = 0; b < tempArr.length; b++) {
        if (tempArr[a].projected.net == tempArr[b].projected.net) {
          counter += 1;
          total +=
            (pointsystem[0]?.point_system[b].value / 100) *
            parseInt(scoreMultiplyer);
        }
      }

      avg = parseFloat(total) / counter;

      points.push(avg);
    }

    // Setting Values
    setPoints(points);
    setRanking(rankingT);
  };

  useEffect(() => {
    if (tournamentLeaderboardProjectedScore?.data?.length > 0) {
      let rankWiseArr = [...tournamentLeaderboardProjectedScore?.data];

      rankWiseArr.sort(
        (a, b) =>
          (a.projected != null ? a.projected.net : Infinity) -
          (b.projected != null ? b.projected.net : Infinity)
      );

      // Player Positioning
      for (let j = 0; j < rankWiseArr.length - 1; j++) {
        if (rankWiseArr[j].projected) {
          if (
            rankWiseArr[j]?.projected?.net ===
            rankWiseArr[j + 1]?.projected?.net
          ) {
            // LOGIC 1
            let sum1 = 0;
            let sum2 = 0;
            for (let a = 17; a >= 9; a--) {
              sum1 += parseInt(rankWiseArr[j].score_card[a].score);
              sum2 += parseInt(rankWiseArr[j + 1].score_card[a].score);
            }

            sum1 = sum1 - rankWiseArr[j].playing_handicap / 2;
            sum2 = sum2 - rankWiseArr[j + 1].playing_handicap / 2;

            if (sum1 === sum2) {
              // LOGIC 2
              sum1 = 0;
              sum2 = 0;

              for (let a = 17; a >= 12; a--) {
                sum1 += parseInt(rankWiseArr[j].score_card[a].score);
                sum2 += parseInt(rankWiseArr[j + 1].score_card[a].score);
              }

              sum1 = sum1 - rankWiseArr[j].playing_handicap / 3;
              sum2 = sum2 - rankWiseArr[j + 1].playing_handicap / 3;

              if (sum1 === sum2) {
                // LOGIC 3
                sum1 = 0;
                sum2 = 0;

                for (let a = 17; a >= 15; a--) {
                  sum1 += parseInt(rankWiseArr[j].score_card[a].score);
                  sum2 += parseInt(rankWiseArr[j + 1].score_card[a].score);
                }

                sum1 = sum1 - rankWiseArr[j].playing_handicap / 6;
                sum2 = sum2 - rankWiseArr[j + 1].playing_handicap / 6;

                if (sum1 === sum2) {
                  // LOGIC 4

                  sum1 = 0;
                  sum2 = 0;

                  for (let a = 0; a <= 8; a++) {
                    sum1 += parseInt(rankWiseArr[j].score_card[a].score);
                    sum2 += parseInt(rankWiseArr[j + 1].score_card[a].score);
                  }

                  sum1 = sum1 - rankWiseArr[j].playing_handicap / 2;
                  sum2 = sum2 - rankWiseArr[j + 1].playing_handicap / 2;

                  if (sum2 < sum1) {
                    let tempp = rankWiseArr[j];
                    rankWiseArr[j] = rankWiseArr[j + 1];
                    rankWiseArr[j + 1] = tempp;
                    j = -1;
                  }
                } else {
                  if (sum2 < sum1) {
                    let tempp = rankWiseArr[j];
                    rankWiseArr[j] = rankWiseArr[j + 1];
                    rankWiseArr[j + 1] = tempp;
                    j = -1;
                  }
                }
              } else {
                if (sum2 < sum1) {
                  let tempp = rankWiseArr[j];
                  rankWiseArr[j] = rankWiseArr[j + 1];
                  rankWiseArr[j + 1] = tempp;
                  j = -1;
                }
              }
            } else {
              if (sum2 < sum1) {
                let tempp = rankWiseArr[j];
                rankWiseArr[j] = rankWiseArr[j + 1];
                rankWiseArr[j + 1] = tempp;
                j = -1;
              }
            }
          } else if (
            rankWiseArr[j]?.projected?.net > rankWiseArr[j + 1]?.projected?.net
          ) {
            let tempp = rankWiseArr[j];
            rankWiseArr[j] = rankWiseArr[j + 1];
            rankWiseArr[j + 1] = tempp;
            j = -1;
          }
        }
      }

      rankingCal(rankWiseArr);
      setPointsystem(tournamentLeaderboardProjectedScore?.pointsystem);
      setScoreMultiplyer(
        tournamentLeaderboardProjectedScore?.points_multiplier
      );
      setLeaderboardProjectedScoreData(rankWiseArr);
    }
  }, [tournamentLeaderboardProjectedScore, pointsystem]);

  const columns = [
    {
      name: <Typography variant="subtitle2"></Typography>,
      selector: (row, params) => {
        if (row.projected) {
          return (
            <div
              onClick={() =>
                rowExpanded === row ? setRowExpanded() : setRowExpanded(row)
              }
            >
              {params === 0 ? (
                <img src={imgMedal1} alt="medal 1" />
              ) : params === 1 ? (
                <img src={imgMedal2} alt="medal 2" />
              ) : params === 2 ? (
                <img src={imgMedal3} alt="medal 3" />
              ) : params === 3 ? (
                <img src={imgMedal4} alt="medal 4" />
              ) : null}
            </div>
          );
        } else {
          return "-";
        }
      },
      width: "80px",
    },
    {
      name: (
        <Typography
          variant="subtitle2"
          sx={{
            width: "100%",
            textAlign: "center",
            fontWeight: 700,
            fontSize: "12px",
          }}
        >
          Rank
        </Typography>
      ),
      selector: (row, params) =>
        row?.projected ? (
          <Chip
            label={filterRank(params)}
            sx={{ width: "50px", fontWeight: 700 }}
            color="success"
            size="small"
            onClick={() =>
              rowExpanded === row ? setRowExpanded() : setRowExpanded(row)
            }
          />
        ) : (
          "-"
        ),
      width: "80px",
      // sortable: true,
    },
    {
      name: (
        <Typography
          variant="subtitle2"
          sx={{
            width: "100%",
            textAlign: "center",
            fontWeight: 700,
            fontSize: "12px",
          }}
        >
          Player Name
        </Typography>
      ),
      width: "200px",
      selector: (row) => {
        let fullName = row?.first_name + " " + row?.last_name;
        return fullName.length > 20
          ? `${fullName.substring(0, 20)}...`
          : fullName;
      },
      sortable: ranking.length > 0 ? false : true,
    },
    {
      name: (
        <Typography
          variant="subtitle2"
          sx={{
            width: "100%",
            textAlign: "center",
            fontWeight: 700,
            fontSize: "12px",
          }}
        >
          Points
        </Typography>
      ),
      selector: (row, params) => getPoints(row, params),
      // sortable: false,
      // cell: (row) => {
      //   console.log("row", row);
      // },
    },
    {
      name: (
        <Typography
          variant="subtitle2"
          sx={{
            width: "100%",
            textAlign: "center",
            fontWeight: 700,
            fontSize: "12px",
          }}
        >
          Playing Handicap
        </Typography>
      ),
      selector: (row) => row?.playing_handicap,
      // sortable: true,
    },
    {
      name: (
        <Typography
          variant="subtitle2"
          sx={{
            width: "100%",
            textAlign: "center",
            fontWeight: 700,
            fontSize: "12px",
          }}
        >
          Gross Score
        </Typography>
      ),
      selector: (row) => {
        return row?.gross_score ? row?.gross_score : "-";
      },
      // sortable: true,
    },
    {
      name: (
        <Typography
          variant="subtitle2"
          sx={{
            width: "100%",
            textAlign: "center",
            fontWeight: 700,
            fontSize: "12px",
          }}
        >
          Net Score
        </Typography>
      ),
      selector: (row) => (row?.projected ? row?.projected.net : "-"),
      // sortable: true,
    },
    {
      name: (
        <Typography
          variant="subtitle2"
          sx={{
            width: "100%",
            textAlign: "center",
            fontWeight: 700,
            fontSize: "12px",
          }}
        >
          FIR
        </Typography>
      ),
      selector: (row) => (row?.fir === null ? "-" : row?.fir),
      width: "80px",
      // sortable: true,
    },
    {
      name: (
        <Typography
          variant="subtitle2"
          sx={{
            width: "100%",
            textAlign: "center",
            fontWeight: 700,
            fontSize: "12px",
          }}
        >
          GIR
        </Typography>
      ),
      width: "80px",
      selector: (row) => (row?.gir === null ? "-" : row?.gir),
      // sortable: true,
    },
    {
      name: (
        <Typography
          variant="subtitle2"
          sx={{
            width: "100%",
            textAlign: "center",
            fontWeight: 700,
            fontSize: "12px",
          }}
        >
          Putts
        </Typography>
      ),
      width: "80px",
      selector: (row) => (row?.putts ? row?.putts : "-"),
    },
  ];

  const customStyles = {
    expanderButton: {
      style: {
        "& > div": {
          display: "none",
        },
        "& > div > button": {
          display: "none !important",
        },
        display: "none !important",
      },
    },
    rows: {
      style: {
        "&:nth-child(even)": {
          backgroundColor: "#F2F2F2",
        },
        "& > div > div": {
          width: "100%",
          display: "flex",
          justifyContent: "center",
        },
        border: "none !important",
      },
    },
    headRow: {
      style: {
        border: "1px solid #C4C4C4",
        borderRadius: "10px",
      },
    },
  };

  return (
    <>
      <Grid container p={2}>
        <Grid
          xs={12}
          sx={{
            maxHeight: "800px",
            minHeight: "300px",
            overflow: "auto",
          }}
          className={classes.scrollBarStyle}
        >
          {tournamentLeaderboardProjectedScoreLoading ? (
            <Box sx={{ textAlign: "center" }}>
              <CircularProgress />
            </Box>
          ) : (
            <DataTable
              columns={columns}
              data={leaderboardProjectedScoreData}
              persistTableHead
              pagination={false}
              direction="vertical"
              // onRowClicked={(row) => setRowExpanded(row)}
              expandableRows
              expandableRowsComponent={ExpandedComponent}
              progressPending={dataProgressPending}
              expandOnRowClicked={true}
              expandableRowExpanded={(row) => row === rowExpanded}
              expandableInheritConditionalStyles={true}
              customStyles={customStyles}
              expandableRowsComponentProps={{ someTitleProp: setRowExpanded }}
            />
          )}
        </Grid>
      </Grid>
    </>
  );
}

const index = (props) => {
  return (
    <Grid container>
      <Grid item xs={12}>
        <POTYTournamentDetails
          leaderboardScoreVal={props.leaderboardScoreVal}
          isLoading={props.isLoading}
          dataProgressPending={props.dataProgressPending}
        />
      </Grid>
    </Grid>
  );
};

export default index;
